import React from 'react';

const sizes = {
  xs: 'w-6 h-6 text-xs',
  sm: 'avatar-sm',
  md: 'avatar-md',
  lg: 'avatar-lg',
  xl: 'w-16 h-16 text-xl'
};

export default function Avatar({
  src,
  alt,
  name,
  size = 'md',
  className = ''
}) {
  const sizeClass = sizes[size] || sizes.md;

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt || name}
        className={`${sizeClass} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div className={`avatar ${sizeClass} ${className}`}>
      {getInitials(name)}
    </div>
  );
}

export function AvatarGroup({ users = [], max = 4, size = 'sm' }) {
  // Deduplicate users by _id
  const uniqueUsers = users.filter((user, index, self) =>
    user && user._id && index === self.findIndex(u => u && u._id === user._id)
  );

  const visible = uniqueUsers.slice(0, max);
  const remaining = uniqueUsers.length - max;

  return (
    <div className="flex -space-x-2 rtl:space-x-reverse">
      {visible.map((user, index) => (
        <Avatar
          key={user._id || `avatar-${index}`}
          src={user.avatar ? (user.avatar.startsWith('http') ? user.avatar : process.env.REACT_APP_SOCKET_URL + user.avatar) : null}
          name={user.firstName ? `${user.firstName} ${user.lastName}` : user.name}
          size={size}
          className="ring-2 ring-white"
        />
      ))}
      {remaining > 0 && (
        <div className={`avatar ${sizes[size]} ring-2 ring-white bg-gray-200 text-gray-600`}>
          +{remaining}
        </div>
      )}
    </div>
  );
}
